import emptySplitApi from "../utils/rtk";
import { User, updateProfile } from "../types/User";
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  data: any;
 
  statusCode: number;
  message: string;
   s3Location?:string
};
 
 
interface CategoryResponse extends CommonResponseType {
  data: any;
}

interface QueryParams {
  userId?: any;
}

export const authApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    postAddNotificatiosn: builder.mutation<
      CommonResponseType & { data: any },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.notification,
        method: "POST",
        body,
      }),
      invalidatesTags:["GETNOTIFICATION"]
    }),
    getAllNotificatiosn: builder.query<CommonResponseType & { data: any },  { page?: number; search?:string;limit?: number ;range?:{ from: string | undefined;
      to: string | undefined;};role?:string|number}>({
      query: ({ page, limit ,range,role,search}) => {
        // let url = END_POINTS.notification;
        let url = `${END_POINTS.notification}?page=${page}&search=${search}&limit=${limit}&startDate=${range?.from}&endDate=${range?.to}&role=${role}`;       
        return {
          url: url,
          method: "GET",
        };
      },
      keepUnusedDataFor:3,
      providesTags:["GETNOTIFICATION"]
    }),
    rcvdAllNotificatios: builder.query<CommonResponseType & { data: any }, { page?: number; search?: string;limit:number }>({
      query: ({ page, search ,limit}) => {
        // let url = END_POINTS.receivedNotification;
        let url = `${END_POINTS.receivedNotification}?page=${page}&search=${search}&limit=${limit}`;
        
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getAllAgent: builder.query<CommonResponseType & { data: any }, {role?:number }>({
        query: ({ }) => {
          let url = END_POINTS.usersListing;
          url+=`?role=3`;
         
          return {
            url: url,
            method: "GET",
          };
        },
      }),
      getAllUserListNotification: builder.query<CommonResponseType & { data: any }, {role?:number }>({
        query: ({ }) => {
          let url = END_POINTS.usersListing;
          url+=`?role=4`;
         
          return {
            url: url,
            method: "GET",
          };
        },
      }),
    
      getAllAgents: builder.query<CommonResponseType & { data: any }, {role?:number }>({
        query: ({ }) => {
          let url = END_POINTS.usersListing;
          url+=`?role=3`;
         
          return {
            url: url,
            method: "GET",
          };
        },
      }),
      getAllCompany: builder.query<CommonResponseType & { data: any }, {role?:number }>({
        query: ({ }) => {
          let url = END_POINTS.usersListing;
          url+=`?role=5`;
         
          return {
            url: url,
            method: "GET",
          };
        },
      }),
    
    
  
    EditNotification: builder.mutation<
    CommonResponseType & { data: CommonBody },
    { id: string | undefined; body: CommonBody }
  >({
    query: ({ body, id }) => ({
      url: `${END_POINTS.notification}/${id}`,
      method: "PUT",
      body,
    }),
  }),
  
    
      
    deleteByIdNotification:  builder.mutation<CommonResponseType & { data: any }, { userId: any}>({
        query: ({ userId }) => ({
          url: `${END_POINTS.notification}/${userId}`,
          method: "DELETE",
        }),
        invalidatesTags:["GETNOTIFICATION"]
      }),
 
  }),
});

export const {
    usePostAddNotificatiosnMutation,
    useGetAllNotificatiosnQuery,

    useDeleteByIdNotificationMutation,
    useLazyGetAllAgentQuery,
    useLazyGetAllAgentsQuery,
    useLazyGetAllCompanyQuery,
    useEditNotificationMutation,
    useLazyGetAllUserListNotificationQuery,
    useLazyRcvdAllNotificatiosQuery
} = authApi;
